"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _member = require("@/api/member/member");
var _superInviter = require("@/api/marketingFunction/superInviter");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SuperInviterIndex',
  data: function data() {
    return {
      // 列表
      loading: false,
      queryData: {
        status: null,
        nickName: '',
        phone: '',
        inviteCode: '',
        page: 1,
        size: 10
      },
      tableData: [],
      total: 0,
      options: [],
      // 添加
      dialogVisible: false,
      titleTxt: '',
      operationType: 'add',
      ruleForm: {
        name: '',
        memberId: null,
        grade: null,
        continued: 0,
        superInviterId: null
      },
      rules: {
        memberId: [{
          required: true,
          message: '请选择用户',
          trigger: 'change'
        }],
        grade: [{
          required: true,
          message: '请选择指定等级',
          trigger: 'change'
        }],
        continued: [{
          required: true,
          message: '选择延续时，当前用户邀请的团队里所有的粉丝，都会延续当前条件下的“超级邀请人身份”',
          trigger: 'blur'
        }]
      },
      // 选择会员-------------------------------------
      dialogVisible1: false,
      queryData1: {
        queryType: 1,
        memberListParam: {
          phone: '',
          // 手机号
          memberId: '',
          // 用户ID
          spreadCodeSystem: '' // 会员name
        },
        page: {
          page: 1,
          size: 10
        }
      },
      userInformation: {},
      tableData1: [],
      // 会员列表数据
      total1: 0 // 条数
      // ------------------------------------------------------
    };
  },
  created: function created() {
    this.memberQueryMemberGradeApi();
    this.onQuerySuperInviterPage();
  },
  methods: {
    // 列表
    onQuerySuperInviterPage: function () {
      var _onQuerySuperInviterPage = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData);
              this.loading = true;
              _context.n = 1;
              return (0, _superInviter.querySuperInviterPage)(params);
            case 1:
              res = _context.v;
              this.loading = false;
              this.tableData = res.data.data;
              this.total = res.data.total;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.loading = false;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function onQuerySuperInviterPage() {
        return _onQuerySuperInviterPage.apply(this, arguments);
      }
      return onQuerySuperInviterPage;
    }(),
    // 查询
    onInquireList: function onInquireList() {
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.onQuerySuperInviterPage();
    },
    // 重置
    onInitializeList: function onInitializeList() {
      this.onQueryDataInit();
      this.onQuerySuperInviterPage();
    },
    // 参数初始化
    onQueryDataInit: function onQueryDataInit() {
      this.queryData = {
        status: null,
        nickName: '',
        phone: '',
        inviteCode: '',
        page: 1,
        size: 10
      };
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.onQuerySuperInviterPage();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.onQuerySuperInviterPage();
    },
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.nickName
        }
      });
    },
    // --------新增----------
    onRecharge: function onRecharge() {
      this.dialogVisible = true;
      this.operationType = 'add';
      this.titleTxt = '添加';
    },
    onClose: function onClose() {
      this.ruleForm = {
        name: '',
        memberId: null,
        grade: null,
        continued: 0,
        superInviterId: null
      };
      this.resetForm('ruleForm');
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var title = '';
          if (_this.operationType === 'add') {
            title = '<div><div>确认选择当前用户作为超级邀请人？</div><div>注意选中后不能更改！</div></div>';
          } else {
            title = '<div>确认修改当前配置？</div>';
          }
          _this.$confirm(title, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            icon: false,
            dangerouslyUseHTMLString: true
          }).then(function () {
            if (_this.operationType === 'add') {
              _this.onAddSuperInviter();
            } else {
              // 编辑
              _this.onEditSuperInviter();
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm() {
      this.ruleForm.name = '';
      this.$refs['ruleForm'].resetFields();
    },
    // 添加接口
    onAddSuperInviter: function () {
      var _onAddSuperInviter = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              if (params.superInviterId) {
                delete params.superInviterId;
              }
              _context2.n = 1;
              return (0, _superInviter.addSuperInviter)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                this.onClose();
                this.onQuerySuperInviterPage();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function onAddSuperInviter() {
        return _onAddSuperInviter.apply(this, arguments);
      }
      return onAddSuperInviter;
    }(),
    // 编辑
    onEditor: function onEditor(data) {
      this.onQuerySuperInviterDetail(data);
    },
    // 编辑接口
    onEditSuperInviter: function () {
      var _onEditSuperInviter = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {
                superInviterId: this.ruleForm.superInviterId,
                grade: this.ruleForm.grade,
                continued: this.ruleForm.continued
              };
              _context3.n = 1;
              return (0, _superInviter.editSuperInviter)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '编辑成功'
                });
                this.onClose();
                this.onQuerySuperInviterPage();
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.log(_t3);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function onEditSuperInviter() {
        return _onEditSuperInviter.apply(this, arguments);
      }
      return onEditSuperInviter;
    }(),
    // 详情
    onQuerySuperInviterDetail: function () {
      var _onQuerySuperInviterDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(data) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              params = {
                id: data.superInviterId
              };
              _context4.n = 1;
              return (0, _superInviter.querySuperInviterDetail)(params);
            case 1:
              res = _context4.v;
              this.operationType = 'editor';
              this.titleTxt = '编辑';
              this.ruleForm = {
                name: res.data.nickName,
                memberId: res.data.memberId,
                grade: res.data.grade,
                continued: res.data.continued,
                superInviterId: null
              };
              this.ruleForm.superInviterId = data.superInviterId;
              this.dialogVisible = true;
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function onQuerySuperInviterDetail(_x) {
        return _onQuerySuperInviterDetail.apply(this, arguments);
      }
      return onQuerySuperInviterDetail;
    }(),
    // 删除
    onDelete: function onDelete(data) {
      var _this2 = this;
      this.$confirm('确认删除此项', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.onDeleteSuperInviter(data.superInviterId);
      });
    },
    // 失败----
    onDeleteSuperInviter: function () {
      var _onDeleteSuperInviter = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(superInviterId) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              params = {
                superInviterId: superInviterId
              };
              _context5.n = 1;
              return (0, _superInviter.deleteSuperInviter)(params);
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '删除成功'
                });
                this.onQuerySuperInviterPage();
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function onDeleteSuperInviter(_x2) {
        return _onDeleteSuperInviter.apply(this, arguments);
      }
      return onDeleteSuperInviter;
    }(),
    // 修改状态
    onStatusChange: function () {
      var _onStatusChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6(val, row) {
        var title, confirmed;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              console.log('val, row', val, row);
              title = '';
              if (row.status) {
                title = '确认关闭当前用户超级邀请人状态?';
              } else {
                title = '确认打开当前用户超级邀请人状态?';
              }
              _context6.n = 1;
              return this.$confirm(title, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).catch(function () {
                return false;
              });
            case 1:
              confirmed = _context6.v;
              if (confirmed !== false) {
                this.onChangeSuperInviterStatus(row);
              }
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function onStatusChange(_x3, _x4) {
        return _onStatusChange.apply(this, arguments);
      }
      return onStatusChange;
    }(),
    onChangeSuperInviterStatus: function () {
      var _onChangeSuperInviterStatus = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee7(val) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              // 	超级邀请人状态 0-禁用 1-启用
              params = {
                superInviterId: val.superInviterId,
                status: val.status ? 0 : 1
              };
              _context7.n = 1;
              return (0, _superInviter.changeSuperInviterStatus)(params);
            case 1:
              res = _context7.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.onQuerySuperInviterPage();
              }
            case 2:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function onChangeSuperInviterStatus(_x5) {
        return _onChangeSuperInviterStatus.apply(this, arguments);
      }
      return onChangeSuperInviterStatus;
    }(),
    // 用户等级
    memberQueryMemberGradeApi: function () {
      var _memberQueryMemberGradeApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee8() {
        var res, _t4;
        return (0, _regenerator2.default)().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _context8.p = 0;
              _context8.n = 1;
              return (0, _member.memberQueryMemberGradeApi)();
            case 1:
              res = _context8.v;
              this.options = res.data;
              _context8.n = 3;
              break;
            case 2:
              _context8.p = 2;
              _t4 = _context8.v;
              console.log(_t4);
            case 3:
              return _context8.a(2);
          }
        }, _callee8, this, [[0, 2]]);
      }));
      function memberQueryMemberGradeApi() {
        return _memberQueryMemberGradeApi2.apply(this, arguments);
      }
      return memberQueryMemberGradeApi;
    }(),
    // ---------选择会员----------------------------------------------------------------------
    // 选择会员
    onAddMemberId: function onAddMemberId(data) {
      this.ruleForm.name = data.nickname;
      this.ruleForm.memberId = data.memberId;
      this.onCloseUser();
    },
    onCloseUser: function onCloseUser() {
      this.onInitializeUser();
      this.dialogVisible1 = false;
    },
    onSelectMember: function onSelectMember() {
      this.dialogVisible1 = true;
    },
    onInquireUser: function onInquireUser() {
      if (this.queryData1.memberListParam.phone || this.queryData1.memberListParam.memberId || this.queryData1.memberListParam.spreadCodeSystem) {
        this.memberQueryMemberListApi();
      }
    },
    memberQueryMemberListApi: function () {
      var _memberQueryMemberListApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee9() {
        var params, res, _t5;
        return (0, _regenerator2.default)().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              _context9.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData1);
              _context9.n = 1;
              return (0, _member.memberQueryMemberListApi)(params);
            case 1:
              res = _context9.v;
              if (res.code === 0) {
                this.tableData1 = res.data.data;
                this.total1 = res.data.total;
              }
              _context9.n = 3;
              break;
            case 2:
              _context9.p = 2;
              _t5 = _context9.v;
              console.log(_t5);
            case 3:
              return _context9.a(2);
          }
        }, _callee9, this, [[0, 2]]);
      }));
      function memberQueryMemberListApi() {
        return _memberQueryMemberListApi2.apply(this, arguments);
      }
      return memberQueryMemberListApi;
    }(),
    onInitializeUser: function onInitializeUser() {
      this.queryData1 = {
        queryType: 1,
        memberListParam: {
          phone: '',
          // 手机号
          memberId: '',
          // 用户ID
          spreadCodeSystem: '' // 会员name
        },
        page: {
          page: 1,
          size: 10
        }
      };
      this.tableData1 = [];
    }
  }
};